import styled from 'styled-components';

const topBarHeight = '5.9375rem';

// TODO: TFR-44 move to TOPBAR
export const TopBar = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${topBarHeight};
  position: sticky;
  top: -1px;
  background: ${({ theme }) => theme.colors.gray1};
  z-index: 1;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  position: sticky;
  top: calc(${topBarHeight} - 1px);
  background: ${({ theme }) => theme.colors.gray1};
  z-index: 1;
`;

export default Header;
